export const hasCompleteInvoiceData = profile => {
  if (!profile) return false;
  const common = [profile.country, profile.city, profile.province, profile.cap];
  if (profile.isBusiness) {
    const business = [profile.businessName, profile.registeredOffice, profile.IVA];
    if (String(profile.country || '').trim().toLowerCase() === 'italia') {
      business.push(profile.sdiPec);
    }
    return [...common, ...business].every(value => String(value || '').trim());
  }
  return [...common, profile.name, profile.surname, profile.address, profile.fiscalCode]
    .every(value => String(value || '').trim());
};

export const askInvoiceRequest = (profile, requested = false) => {
  if (!requested) {
    return {invoiceRequested: false, blocked: false};
  }
  if (!hasCompleteInvoiceData(profile)) {
    return {invoiceRequested: false, blocked: true};
  }
  return {invoiceRequested: true, blocked: false};
};
